/**
 * Post-training feedback scales — single source for the wording
 * (matches the firm's Microsoft Forms survey word for word; do not reword).
 *
 * What is stored in `ld_feedback` is a plain 1-5 integer per question; only the
 * wording lives here. Three surfaces read it — the employee form, the dashboard
 * Training Feedback tab and the session detail panel — so a score can never
 * read differently on two screens.
 */

export const EFFECTIVENESS_LABELS = {
  1: 'Very ineffective',
  2: 'Ineffective',
  3: 'Neutral/Moderate',
  4: 'Effective',
  5: 'Very effective',
};

export const COMPETENCY_LABELS = {
  1: '(1) Low',
  2: '(2) Basic Knowledge',
  3: '(3) Competent',
  4: '(4) Proficient',
  5: '(5) Mastery',
};

// Same scale without the leading "(n)" — for the employee form, where the
// button already carries the number and printing it twice reads as a typo.
export const COMPETENCY_SHORT = {
  1: 'Low',
  2: 'Basic Knowledge',
  3: 'Competent',
  4: 'Proficient',
  5: 'Mastery',
};

// Badge colours by score (unchanged wording→colour pairing, keyed by the score
// itself so relabelling never breaks the lookup).
export const EFFECTIVENESS_COLOR = {
  5: 'bg-emerald-100 text-emerald-800',
  4: 'bg-green-100 text-green-700',
  3: 'bg-amber-100 text-amber-700',
  2: 'bg-orange-100 text-orange-700',
  1: 'bg-red-100 text-red-700',
};

/**
 * "3/5 · Neutral/Moderate" for read-only surfaces; em dash when unanswered.
 *
 * The label alone does not say where it sits on the scale
 * (只顯示標籤看不出程度), so every read-side surface prints the score
 * out of 5 next to it. Pass COMPETENCY_SHORT rather than COMPETENCY_LABELS —
 * the latter already carries a leading "(n)" and would print the number twice.
 */
export const scoreLabel = (v, labels) => (v == null ? '—' : `${v}/5 · ${labels[v] || ''}`);
